export default __webpack_public_path__ + "static/media/item_2_active.31bf2d6a.png";